import { useContext } from 'react';

import parse from 'html-react-parser';
import _ from 'lodash';

import type { AllBlocks } from '@/src/Types/Shared/Common';

import { Translations } from './Translations';

declare const pll_activated: boolean;

export function getTitleWithClass(title: string | undefined) {
	if (title) {
		const pattern = /\[([a-zA-Z0-9]+)\](.*?)\[\/\1\]/g;
		const matches = [...title.matchAll(pattern)];

		if (matches.length > 0) {
			matches.forEach((match) => {
				const balise = match[1];

				title = title?.replace(`[${balise}]`, `<span class="${balise}">`);
				title = title?.replace(`[/${balise}]`, `</span>`);
			});
		}

		return parse(title);
	} else {
		return title;
	}
}

export function parseURL(location: string): any {
	let searchString = '';
	const hashPos = location.indexOf('#');
	let searchPos = location.indexOf('?');
	if (hashPos < searchPos && hashPos >= 0) {
		searchPos = -1;
	}
	if (searchPos > -1) {
		searchString = location.slice(searchPos + 1, hashPos > -1 ? hashPos : location.length);
	}

	const searchParams = searchString.split('&');

	const object: Record<string, string> = {};

	searchParams.forEach((param) => {
		const splitted = param.split('=');
		const key = splitted[0];
		const value = splitted[1];

		object[key] = value;
	});

	return object;
}

export function __Front(str: string) {
	const TranslationsArr = useContext(Translations);
	const _str = _.find(TranslationsArr, { name: str });

	if (!_str) {
		return str;
	} else {
		return _str.translation;
	}
}

export function getBlocksUse(blocks: AllBlocks[]) {
	const list = _.compact(_.uniq(_.map(blocks, 'block')));
	return list.map((str) => str.replace('minos/', ''));
}

export const getTranslationsWithoutPLL = (str: string | undefined, translation: string) => {
	return pll_activated ? translation : str;
};
